import DropDown from "./components/Dropdown.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import { CollapseTransition, SlideYDownTransition, FadeTransition, ZoomCenterTransition, } from "vue2-transitions";
const vSelectAny = vSelect;
vSelectAny.props.components.default = () => ({
    OpenIndicator: {
        render: (h) => h("span", ""),
    },
});
const GlobalComponents = {
    install(Vue) {
        Vue.component("drop-down", DropDown);
        Vue.component("ValidationProvider", ValidationProvider);
        Vue.component("ValidationObserver", ValidationObserver);
        Vue.component("CollapseTransition", CollapseTransition);
        Vue.component("SlideYDownTransition", SlideYDownTransition);
        Vue.component("FadeTransition", FadeTransition);
        Vue.component("ZoomCenterTransition", ZoomCenterTransition);
        Vue.component("v-select", vSelect);
    },
};
export default GlobalComponents;
